$.ajaxSetup({
  beforeSend: function (xhr) {
    if (!this.crossDomain) {
      xhr.setRequestHeader('X-CSRF-Token', $('meta[name="csrf-token"]').attr('content'));
    }
  }
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy/init/ajaxCSRF.js